export const isLoggedIn = state => !!state.currentUser;

export const isLoggedOut = (state, getters) => !getters.isLoggedIn;

export const isCheckSessionYet = state => state.isCheckSessionYet;
